export const INITIAL_FORM_PRODUTO_VMP = () => ({
  produtoVmpId: 0,
  diretrizId: 0,
});

export const INITIAL_FORM_PRODUTO_MEDSUS = () => ({
  id: 0,
  produtoVmpId: 0,
  produtoVmpNome: '',
  obmCodigo: '',
});

export const INITIAL_FORM_PRODUTO_MEDSUS_DIRETRIZ = (
  userID: number | string,
) => ({
  id: 0,
  usuarioId: Number(userID),

  status: '',
  tipo: '',
  respAquisicao: '',
  respFinanciamento: '',
  componenteAF: '',
  grupoFinanciamento: '',
  nome: '',
  abrangencia: 'Teste',
  descricao: '',
  linkCidadao: '',
  linkFarmaceutico: '',
  dataDisponibilizacao: '',
  dataExclusao: '',

  item: null,
  //Observações
  observacoes: '',
});

export const INITIAL_FORM_PRODUTO_MEDSUS_CRITERIO = (
  userID: number | string,
  diretrizMedsusVmpId: number,
) => ({
  id: 0,
  usuarioId: Number(userID),

  statusCriterio: '',
  tipoCriterio: '',
  tituloCriterio: '',
  descricaoCriterio: '',

  diretrizVmp: undefined,
  diretrizVmpId: diretrizMedsusVmpId,
  //Observações
  observacoes: '',
});

export const INITIAL_FORM_PRODUTO_MEDSUS_DOCUMENTO = (
  userID: number | string,
  diretrizMedsusVmpId: number,
) => ({
  id: 0,
  usuarioId: Number(userID),

  subtipoDocumentoId: undefined,
  subtipoExameId: undefined,

  subtipoDocumento: undefined,
  subtipoExame: undefined,

  statusDocumento: '',
  tipoDocumento: '',
  finalidade: '',
  detalhamento: '',

  diretrizVmp: undefined,
  diretrizVmpId: diretrizMedsusVmpId,
  //Observações
  observacoes: '',
});

export const INITIAL_FORM_PRODUTO_MEDSUS_CID = (
  userID: number | string,
  diretrizMedsusVmpId: number,
) => ({
  id: 0,
  usuarioId: Number(userID),

  status: '1',
  dtInclusaoDiretriz: '',
  dtExclusaoDiretriz: '',

  diretrizVmp: undefined,
  diretrizVmpId: diretrizMedsusVmpId,
  cid: undefined,
  cidId: 0,

  //Observações
  observacoes: '',
});
